'use client'
import { Icon } from '@/components'
import { formatDiscountLabel } from '@/features/cart/utils'
import { getVND } from '@/utils/helpers'
import { Divider, Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

export const PaymentDetail = ({ totalData, discounts }: { totalData: any; discounts: IDiscount[] }) => {
  const t = useTranslations('Order')

  // const renderLoading = (content: ReactNode) => {
  //   if (isLoading) return <Skeleton variant="text" width={90} height={40} />
  //   return content
  // }

  return (
    <Stack spacing={2}>
      <Typography variant="h6" sx={{ fontSize: { xs: '1rem', sm: '1.5rem' } }} fontWeight={600}>
        {t('Chi tiết thanh toán')}
      </Typography>
      <Stack spacing={1}>
        <Stack spacing={2} alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
          <Typography variant="body2" fontWeight={300}>
            {t('Tạm tính')}
          </Typography>
          <Typography fontWeight={600} fontSize={{ xs: '1rem', md: '1.125rem' }} lineHeight={1.3}>
            {getVND(totalData?.subtotal?.value)}
          </Typography>
        </Stack>
        <Stack spacing={2} alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
          <Typography variant="body2" fontWeight={300}>
            {' '}
            {t('Phí giao hàng')}
          </Typography>
          {totalData?.shipping_handling?.amount_excluding_tax?.value === 0 ? (
            <Typography
              fontWeight={600}
              color="#09AD61"
              fontSize={{ xs: '1rem', md: '1.125rem' }}
              lineHeight={1.3}
            >
              Miễn phí
            </Typography>
          ) : (
            <Typography fontWeight={600} fontSize={{ xs: '1rem', md: '1.125rem' }} lineHeight={1.3}>
              {getVND(totalData?.shipping_handling?.amount_excluding_tax?.value)}
            </Typography>
          )}
        </Stack>
        {totalData?.discounts?.length > 0 && (
          <>
            <Stack spacing={2} alignItems={'flex-start'} direction={'row'} justifyContent={'space-between'}>
              <Typography variant="body2" fontWeight={300}>
                {t('Khuyến mãi áp dụng')}:
              </Typography>
              <Typography variant="body2" color="#F04438" fontWeight={600}>
                -{getVND(totalData?.subtotal?.value - totalData?.grand_total?.value)}
              </Typography>
            </Stack>
            {discounts?.map((discountItem: any, index: number) => (
              <Stack
                key={index}
                direction="row"
                sx={{ fontSize: { xs: '12px', lg: '14px' } }}
                alignItems="center"
                justifyContent="space-between"
                spacing={1}
              >
                <Stack direction="row" alignItems={'flex-start'} gap={1} fontSize={'inherit'} flex={1}>
                  <Icon.CheckCircle
                    color="primary"
                    sx={{
                      fontSize: { xs: '0.75rem', md: '1rem' },
                      mt: 0.3,
                    }}
                  />
                  <Typography width={'100%'} sx={{ fontSize: 'inherit', fontWeight: 300 }}>
                    {formatDiscountLabel(discountItem)}
                  </Typography>
                </Stack>
                <Typography sx={{ fontSize: 'inherit', fontWeight: 300 }}>
                  -{getVND(discountItem?.amount?.value, discountItem?.amount?.currency)}
                </Typography>
              </Stack>
            ))}
          </>
        )}
      </Stack>
      <Stack spacing={1}>
        <Divider sx={{ background: '#BBBBBA', width: '100%', height: '1px' }} />
        <Stack
          gap={2}
          alignItems={'center'}
          direction={'row'}
          flexWrap="wrap"
          justifyContent={'space-between'}
        >
          <Typography fontWeight={600} fontSize={{ xs: '1rem', md: '1.125rem' }} lineHeight={1.3}>
            {t('Tổng tiền')}
          </Typography>
          <Stack alignItems="flex-end">
            <Typography
              color="primary"
              fontWeight={600}
              lineHeight={1}
              fontSize={{ xs: '1.5rem', sm: '1.75rem', md: '2rem' }}
            >
              {getVND(totalData?.grand_total?.value)}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
